import { combineReducers } from "redux";
import { csuState } from "./csuReducer";

export const csuReducer = combineReducers({
  csuState: csuState
});

